import React from "react";
import { FlameIcon, GlobeIcon } from "lucide-react";
export function ScarcityBar() {
  return <div className="w-full" data-id="element-57" data-mp="2ywuk6w01eeh3">
      <div className="rounded-2xl border-2 border-danger/20 bg-danger-light p-4" data-id="element-58" data-mp="2yv1bzc9rzm6z">
        <div className="flex items-center justify-between gap-2" data-id="element-59" data-mp="2l3v3wrsfkg8h">
          <span className="flex items-center gap-1.5 text-sm font-extrabold uppercase tracking-wide text-danger" data-id="element-60" data-mp="2q3r7wr14o7o1">
            <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-61" data-mp="2b68kpt43m2ip" />
            Limited launch price
          </span>
          <span className="text-sm font-extrabold text-danger" data-id="element-62" data-mp="2g6w9s98ro9aa">93% claimed</span>
        </div>
        <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white ring-1 ring-danger/20" role="progressbar" aria-valuenow={93} aria-valuemin={0} aria-valuemax={100} aria-label="Launch copies claimed" data-id="element-63" data-mp="226ty54r1yc3h">
          <div className="relative h-full rounded-full bg-danger" style={{
          width: "93%"
        }} data-id="element-64" data-mp="5eble88xz547">
            <span className="absolute right-1 top-1/2 h-2 w-2 -translate-y-1/2 animate-pulse rounded-full bg-white" data-id="element-65" data-mp="33mmw0xi48fx6" />
          </div>
        </div>
        <p className="mt-3 text-center text-[15px] font-semibold text-ink" data-id="element-66" data-mp="2zkrv3u43k4jx">
          Only <span className="font-black text-danger" data-id="element-67" data-mp="3dbmwklc9njdh">7 copies</span> remain at the $27 launch price.
        </p>
      </div>
      <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-sm text-ink-muted" data-id="element-68" data-mp="38e4unewo24ez">
        <GlobeIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-69" data-mp="2koak53ztkrxw" />
        Currency conversion is automatically handled according to your country.
      </p>
    </div>;
}